<template>
  <div class="details-sub-tabs-comments">
    <div v-if="commentsList">
      <div class="details-sub-tabs-comments-details">
        <div
          v-for="(item, index) in comments.content"
          :key="`${item.author}-${index}`"
          class="details-sub-tabs-comments-details-container">
          <div class="details-sub-tabs-comments-details-container-icon">
            <avatar
              :image="
                require('../../../public/assets/images/icons/userComment.svg')
              "
              alt="user comment icon"
              :size="40" />
          </div>

          <div class="details-sub-tabs-comments-details-container-comment">
            <div
              class="details-sub-tabs-comments-details-container-comment-username">
              <span
                class="details-sub-tabs-comments-details-container-comment-username--bold">
                {{ item.author || "N/A" }}
              </span>
            </div>

            <div
              class="details-sub-tabs-comments-details-container-comment-time">
              <span class="mi-20px mi-arrow-clockwise-clock"></span>
              <span
                class="details-sub-tabs-comments-details-container-comment-time-contents">
                {{ getTime(item.updatedDateTime) }}
              </span>
            </div>

            <div
              class="details-sub-tabs-comments-details-container-comment-description">
              <p
                v-if="checkHTML(item.descriptionHtml)"
                class="details-sub-tabs-comments-details-container-comment-description-contents"
                v-html="replaceNewLineWithBr(item.descriptionHtml)"></p>
              <p
                v-else
                v-html="
                  item.descriptionHtml
                    ? replaceNewLineWithBr(item.descriptionText)
                    : 'N/A'
                "></p>
            </div>
          </div>

          <!-- Accept and Reject Icons -->
          <div
            v-if="
              ((item.author === 'OHP-Dispute-App-Dev' ||
                item.author === 'OHP-Dispute-App-CDT' ||
                item.author === 'OHP-Dispute-App-PreProd' ||
                item.author === 'OHP-Dispute-App') &&
                (item.commentsSource === 'gpt-35-turbo' ||
                  item.commentsSource === 'gpt-4o-mini') &&
                item.summaryRejectedByAgent === null) ||
              item.summaryRejectedByAgent === false ||
              item.summaryRejectedByAgent === true
            "
            class="details-sub-tabs-comments-actions">
            <div
              v-if="item.summaryRejectedByAgent === true"
              class="status-message rejected">
              Rejected
            </div>
            <div
              v-else-if="item.summaryRejectedByAgent === false"
              class="status-message accepted">
              Accepted
            </div>
            <div v-else class="status-message-parent">
              <button class="action-button" @click="openEditPopup(item)">
                <img
                  src="@/assets/images/icons/pencil.svg"
                  alt="Edit"
                  class="icon" />
              </button>
              <button class="action-button" @click="openAcceptPopup(item)">
                <img
                  src="@/assets/images/icons/check.svg"
                  alt="Accept"
                  class="icon" />
              </button>

              <button class="action-button" @click="openRejectPopup(item)">
                <img
                  src="@/assets/images/icons/times.svg"
                  alt="Reject"
                  class="icon" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        v-if="comments.totalPages > 1"
        :total-items="comments.totalElements"
        :current-page="comments.number + 1"
        :page-size="comments.size"
        :page-count="comments.totalPages"
        @onPageChange="onChangePage" />
    </div>
    <AcceptCommentsModal
      v-if="showAcceptModal"
      :active="showAcceptModal"
      @onModalClose="closeAcceptPopup"
      @onAccept="submitAccept(item)" />
    <EditCommentsModal
      v-if="showEditModal"
      :active="showEditModal"
      :current-description="currentDescription"
      @onModalClose="closeEditPopup"
      @onEdit="submitEdit" />
    <RejectCommentsModal
      v-if="showRejectModal"
      :active="showRejectModal"
      :reject-reasons="rejectReasons"
      @onModalClose="closeRejectPopup"
      @onReject="submitReject" />
  </div>
</template>
  
  <script>
// Utils
import { format } from "date-fns";
import { replaceNewLineWithBr } from "@/utils/helpers";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
// Actions
import { disputeActions } from "@/actions";

// Helpers
import { getMsalIdToken } from "@/utils/helpers.js";
import { showToast } from "@/components/common/Toast";

import AcceptCommentsModal from "@/components/DisputeCommentsModal/AcceptCommentsModal.vue";
import EditCommentsModal from "@/components/DisputeCommentsModal/EditCommentsModal.vue";
import RejectCommentsModal from "@/components/DisputeCommentsModal/RejectCommentsModal.vue";
const CommentAction = {
  ACCEPT: "ACCEPT",
  REJECT: "REJECT",
};
export default {
  name: "DisputeComments",
  components: {
    AcceptCommentsModal,
    EditCommentsModal,
    RejectCommentsModal,
  },
  props: {
    comments: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    caseDetails: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      errorMessage: "Please Enter Alphanumeric Comments.",
      comment: "",
      showRejectModal: false,
      showAcceptModal: false,
      showEditModal: false,
      selectedReason: "",
      rejectReasons: [
        "Misinformation on freetime",
        "Misinformation on Per Diem rates",
        "Incomplete or missing information on contract",
        "Dispute for Service failure",
        "Dispute for other issue ( technical / currency )",
        "Dispute for other issue ( Duplicate / Partial invoice )",
        "Non-programmable deal",
        "Already paid case",
      ],
      currentItem: null,
      currentDescription: "",
      editorError: false,
    };
  },
  computed: {
    commentsList() {
      return (this.comments?.content || []).length;
    },
  },
  methods: {
    replaceNewLineWithBr,
    getTime(time) {
      try {
        return time ? format(new Date(time), "dd-MMM-yyyy hh:mm a") : "N/A";
      } catch (err) {
        return "N/A";
      }
    },
    onChangePage(selected) {
      const top = document.querySelector(".details-tab-area")?.offsetTop || 0;
      this.$emit("fetchDisputeComments", 10, selected - 1);
      window.scrollTo(0, top - 100);
    },
    checkHTML(html) {
      const doc = document.createElement("div");
      doc.innerHTML = html;
      return doc.innerHTML === html;
    },
    async acceptComment(item) {
      //console.log("case details : " + this.caseDetails?.ohpDisputeId);
      let ohpDisputeId = item.ohpDisputeId;
      let commentId = item.commentsId;
      let summarizationUpdateRequest = {
        summary: "ACCEPT",
      };

      try {
        const chargeCodeVal = this.caseDetails?.chargeCode
          ? this.caseDetails?.chargeCode.split("-")[0]
          : "";
        let vectorDbDetailsRequest = {
          customer_id: this.caseDetails?.customer,
          charge_code: chargeCodeVal,
          invoice_type: this.caseDetails?.disputeType,
          summary: item.descriptionText,
          summary_status: "Accepted",
        };
        const responsevector = await AxiosFetchForMsal(
          await disputeActions.updateVectorDetails(
            vectorDbDetailsRequest,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (responsevector.status === 200) {
          const response = await AxiosFetchForMsal(
            await disputeActions.updateSummarizationComments(
              ohpDisputeId,
              commentId,
              summarizationUpdateRequest,
              `Bearer ${await getMsalIdToken(this)}`
            )
          );
          if (response.status === 200) {
            let summaryActionedData = {
              isSummaryActioned: "Yes",
            };
            try {
              const { data } = await AxiosFetchForMsal(
                disputeActions.updateSummaryActioned(
                  ohpDisputeId,
                  summaryActionedData,
                  `Bearer ${await getMsalIdToken(this)}`
                )
              );
              if (data) {
                showToast(
                  "success",
                  "Summary Actioned for dispute updated successfully!"
                );
                window.location.reload();
              }
            } catch (err) {
              showToast("error", err);
              console.error(err);
            }
          } else {
            showToast("error", "Unable to update summary.Please try again. ");
          }
        }
      } catch (error) {
        showToast("error", "Unable to update summary.Please try again. ");
        console.error("Error accepting comment:", error);
      }
    },
    async openEditPopup(item) {
      //console.log("Opening edit popup", item);
      this.showEditModal = true;
      this.currentItem = item;
      this.currentDescription = item.descriptionText; // Load the existing HTML content
      //console.log("showEditModal after opening:", this.showEditModal);
    },
    closeEditPopup() {
      //console.log("Closing reject popup");
      this.showEditModal = false;
      // this.currentDescription = "";
      this.currentItem = null;
      //console.log("showEditModal after close:", this.showEditModal);
    },
    onEditorChange({ html }) {
      this.currentDescription = html; // Store the updated HTML
    },
    async submitEdit(newDescription) {
      if (this.currentDescription.trim() === "") {
        this.editorError = true; // Set error if the description is empty
        return;
      }
      //console.log("Submitting edit for item:", this.currentItem);
      //console.log("current desc before vector call :  " + newDescription);
      let ohpDisputeId = this.currentItem.ohpDisputeId;
      let commentId = this.currentItem.commentsId;
      let summarizationUpdateRequest = {
        descriptionText: newDescription.html, // <-- Use newDescription here
        summary: "ACCEPT",
      };
      const payload = await disputeActions.updateSummarizationComments(
        ohpDisputeId,
        commentId,
        summarizationUpdateRequest,
        `Bearer ${await getMsalIdToken(this)}`
      );

      try {
        const chargeCodeVal = this.caseDetails?.chargeCode
          ? this.caseDetails?.chargeCode.split("-")[0]
          : "";
        let vectorDbDetailsRequest = {
          customer_id: this.caseDetails?.customer,
          charge_code: chargeCodeVal,
          invoice_type: this.caseDetails?.disputeType,
          summary: this.currentDescription,
          summary_status: "Accepted",
        };
        const responsevector = await AxiosFetchForMsal(
          await disputeActions.updateVectorDetails(
            vectorDbDetailsRequest,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        //console.log("Edited comment", response.status);
        //console.log("current desc : " + this.currentDescription);
        if (responsevector.status === 200) {
          const response = await AxiosFetchForMsal(payload);
          if (response.status === 200) {
            let summaryActionedData = {
              isSummaryActioned: "Yes",
            };
            try {
              const { data } = await AxiosFetchForMsal(
                disputeActions.updateSummaryActioned(
                  ohpDisputeId,
                  summaryActionedData,
                  `Bearer ${await getMsalIdToken(this)}`
                )
              );
              if (data) {
                showToast(
                  "success",
                  "Summary Actioned for dispute updated successfully!"
                );
                window.location.reload();
              }
            } catch (err) {
              showToast("error", err);
              console.error(err);
            }
          } else {
            showToast("error", "Unable to update summary.Please try again. ");
          }
        }
      } catch (error) {
        showToast("error", "Unable to update summary. Please try again.");
        console.error("Error editing comment:", error);
      }
    },

    async openRejectPopup(item) {
      //console.log("Opening reject popup", item);
      this.showRejectModal = true;
      this.currentItem = item;
    },
    closeRejectPopup() {
      //console.log("Closing reject popup");
      this.showRejectModal = false;
      this.selectedReason = "";
      this.currentItem = null;
    },
    async submitReject(selectedReason) {
      let currentSummary = this.currentItem.descriptionText;

      if (selectedReason) {
        //console.log("Rejected with reason:", selectedReason);
        this.showRejectModal = false;
      }
      let ohpDisputeId = this.currentItem.ohpDisputeId;
      let commentId = this.currentItem.commentsId;
      let summarizationUpdateRequest = {
        summary: "REJECT",
        summaryRejectionReason: selectedReason,
      };
      const payload = await disputeActions.updateSummarizationComments(
        ohpDisputeId,
        commentId,
        summarizationUpdateRequest,
        `Bearer ${await getMsalIdToken(this)}`
      );

      try {
        const chargeCodeVal = this.caseDetails?.chargeCode
          ? this.caseDetails?.chargeCode.split("-")[0]
          : "";
        let vectorDbDetailsRejectRequest = {
          customer_id: this.caseDetails?.customer,
          charge_code: chargeCodeVal,
          invoice_type: this.caseDetails?.disputeType,
          summary: currentSummary,
          summary_status: "Rejected",
          rejection_reason: selectedReason,
        };
        const rejectResponseVector = await AxiosFetchForMsal(
          await disputeActions.updateVectorDetails(
            vectorDbDetailsRejectRequest,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );

        if (rejectResponseVector.status === 200) {
          const response = await AxiosFetchForMsal(payload);
          if (response.status === 200) {
            let summaryActionedData = {
              isSummaryActioned: "Yes",
            };
            try {
              const { data } = await AxiosFetchForMsal(
                disputeActions.updateSummaryActioned(
                  ohpDisputeId,
                  summaryActionedData,
                  `Bearer ${await getMsalIdToken(this)}`
                )
              );
              if (data) {
                showToast(
                  "success",
                  "Summary Actioned for dispute updated successfully!"
                );
                window.location.reload();
              }
            } catch (err) {
              showToast("error", err);
              console.error(err);
            }
            //console.log("vector response is : " + rejectResponseVector);
          }
        } else {
          showToast("error", "Unable to update summary. Please try again.");
        }
      } catch (error) {
        showToast("error", "Unable to update summary. Please try again.");
        console.error("Error rejecting comment:", error);
      }
    },
    async openAcceptPopup(item) {
      //console.log("Opening accept popup", item);
      this.showAcceptModal = true;
      this.currentItem = item;
    },
    async closeAcceptPopup() {
      //console.log("Closing accept popup");
      this.showAcceptModal = false;
      this.currentItem = null;
    },
    async submitAccept() {
      if (this.currentItem) {
        //console.log("Submitting accept for item:", this.currentItem);
        try {
          await this.acceptComment(this.currentItem);
          this.closeAcceptPopup();
        } catch (error) {
          console.error("Error accepting comment:", error);
        }
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.details-sub-tabs-comments {
  &-details {
    background: var(--Gray-100);
    &-container {
      display: flex;
      align-items: flex-start;
      padding: 1rem;
      border-bottom: 1px solid var(--Gray-300);
      &-icon {
        width: 5%;
      }
      &-comment {
        width: 95%;
        &-username {
          &--bold {
            font-family: "Maersk Text Bold";
          }
        }
        &-time {
          margin-top: 0.5rem;
          display: flex;
          align-items: flex-end;
        }
        &-description {
          margin-top: 0.5rem;
          &-contents {
            overflow: auto;
          }
        }
      }
    }
  }

  &-actions {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    .action-button {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px 8px;
      width: 40px;
      height: 40px;
      border: 1px solid var(--Gray-300);
      border-radius: 8px;
      background-color: white;
      cursor: pointer;
      transition: background-color 0.3s ease;
      &:hover {
        background-color: var(--Gray-200);
      }
      i {
        font-size: 1.5rem;
        color: var(--Gray-600);
      }
    }
  }
}
.status-message {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.9rem;
  white-space: nowrap;
  color: #fff;
  &.accepted {
    background-color: green;
  }
  &.rejected {
    background-color: red;
  }
}
.status-message-parent {
  display: flex;
}
</style>